import { render, staticRenderFns } from "./act-filter.vue?vue&type=template&id=6636d0d8"
import script from "./act-filter.vue?vue&type=script&lang=js"
export * from "./act-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports